import {
    HomeView,
    UnauthorizedView,
    ExpedientesView,
    PersonasFisicasView,
    PersonaFisicaView,
    PersonasJuridicasView,
    PersonaJuridicaView,
    PageNotFoundView,
    EntidadesView,
    EntidadView,
    FirmaDigitalView
} from '../views';

import { TIPS } from "../consts/tips";

export const PrivateRoutes = [
  {
    index: 0,
    code: "home",
    path: "/",
    component: HomeView,
    tipName: TIPS.NAME.ROUTES.HOME_VIEW,
    title: "Home",
    showHeader: true,
    nivelMenu: 0,
    children: []
  },
  {
    index: 10,
    code: "unauthorized",
    path: "/unauthorized",
    component: UnauthorizedView,
    title: "Unauthorized",
    showHeader: false,
    nivelMenu: 0,
    children: []
  },
  {
    index: 20,
    code: "expediente_view",
    path: "/expedientes",
    component: ExpedientesView,
    tipName: TIPS.NAME.ROUTES.EXPEDIENTES_VIEW,
    title: "Expedientes",
    showHeader: true,
    nivelMenu: 1,
    children: []
  },
  {
    index: 30,
    path: "",
    component: null,
    title: "Personas",
    showHeader: true,
    nivelMenu: 1,
    children: [31,33]
  },
  {
    index: 31,
    code: "persona-fisica_view",
    path: "/personas-fisicas",
    component: PersonasFisicasView,
    tipName: TIPS.NAME.ROUTES.PERSONAS_FISICAS_VIEW,
    title: "Personas físicas",
    showHeader: true,
    nivelMenu: 2,
    children: []
  },
  {
    index: 32,
    code: "persona-fisica_view",
    path: ["/persona-fisica/:mode", "/persona-fisica/:mode/:id"],
    component: PersonaFisicaView,
    tipName: TIPS.NAME.ROUTES.PERSONA_FISICA_FORM,
    title: "Persona física",
    showHeader: true,
    nivelMenu: 0,
    children: []
  },
  {
    index: 53,
    code: "persona-fisica_view",
    path: ["/persona-fisica/nh/:mode", "/persona-fisica/nh/:mode/:id"],
    component: PersonaFisicaView,
    tipName: TIPS.NAME.ROUTES.PERSONA_FISICA_FORM,
    title: "Persona física",
    showHeader: false,
    nivelMenu: 0,
    children: []
  },
  {
    index: 33,
    code: "persona-juridica_view",
    path: "/personas-juridicas",
    component: PersonasJuridicasView,
    tipName: TIPS.NAME.ROUTES.PERSONAS_JURIDICAS_VIEW,
    title: "Personas jurídicas",
    showHeader: true,
    nivelMenu: 2,
    children: []
  },
  {
    index: 34,
    code: "persona-juridica_view",
    path: ["/persona-juridica/:mode", "/persona-juridica/:mode/:id"],
    component: PersonaJuridicaView,
    tipName: TIPS.NAME.ROUTES.PERSONA_JURIDICA_FORM,
    title: "Persona jurídica",
    showHeader: true,
    nivelMenu: 0,
    children: []
  },
  {
    index: 54,
    code: "persona-juridica_view",
    path: ["/persona-juridica/nh/:mode", "/persona-juridica/nh/:mode/:id"],
    component: PersonaJuridicaView,
    tipName: TIPS.NAME.ROUTES.PERSONA_JURIDICA_FORM,
    title: "Persona jurídica",
    showHeader: false,
    nivelMenu: 0,
    children: []
  },
  {
    index: 40,
    code: "firma-digital_view",
    path: "/firmas-digitales",
    component: FirmaDigitalView,
    tipName: TIPS.NAME.ROUTES.FIRMAS_DIGITALES_VIEW,
    title: "Firmas digitales",
    showHeader: true,
    nivelMenu: 1,
    children: []
  },
    // Configuración
  {
    index: 50,
    path: "",
    component: null,
    title: "Configuración",
    showHeader: true,
    nivelMenu: 1,
    children: [51]
  },
  {
    index: 51,
    code: "listas_administracion_view",
    path: "/entidades",
    component: EntidadesView,
    tipName: TIPS.NAME.ROUTES.LISTAS_VIEW,
    title: "Listas",
    showHeader: true,
    nivelMenu: 2,
    children: []
  },
  {
    index: 52,
    code: "listas_administracion_view",
    path: "/entidad/:mode/:tipo",
    component: EntidadView,
    tipName: TIPS.NAME.ROUTES.ENTIDAD_FORM,
    title: "Entidad",
    showHeader: true,
    nivelMenu: 0,
    children: []
  },
  {
    index: 999,
    code: "not-found",
    path: "*",
    component: PageNotFoundView,
    tipName: TIPS.NAME.ROUTES.NOT_FOUND,
    title: "Página no encontrada",
    showHeader: false,
    nivelMenu: 0,
    children: []
  },
];
